import React, { Component } from "react";

import SelectFilter from "../SelectFilter";

class LeadSourceFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [
        {
          value: -1,
          label: "N/A"
        },
        {
          value: "dealmachine_street",
          label: "From DealMachine Street Engine"
        },
        {
          value: "mobile_map",
          label: "From Mobile Map"
        },
        {
          value: "chrome_extension",
          label: "From Chrome Extension"
        },
        {
          value: "desktop_map",
          label: "From Desktop Map"
        },
        {
          value: "manually_added",
          label: "Manually Added"
        },
        {
          value: "bulk_import",
          label: "From Bulk Import"
        },
        {
          value: "build_list",
          label: "From List Engine"
        }
      ]
    };
  }

  render() {
    return (
      <SelectFilter
        filter_title="Lead Source:"
        filter_options={this.state.options}
        filter_value={this.props.filters.lead_source}
        filter_prop={"lead_source"}
        filter_search={this.props.filter_search}
        editLeadFilter={this.props.editLeadFilter}
      />
    );
  }
}

export default LeadSourceFilter;
